import React from 'react';
import PropTypes from 'prop-types';

import ListItem from './ListItem';
import { seasonalPerks, annualPerks } from '../../TrialUpgrade/constants';
import { Plans } from '../../constants';
import './styles.scss';

const PerksList = ({ membership }) => {
  const currentList = membership === Plans.SEASONAL ? seasonalPerks : annualPerks;
  const renderListItem = (list, start, end) => (
    Array.isArray(list)
    && list.slice(start, end)
      .map(({ label, check }) => (
        <ListItem label={label} check={check} />
      ))
  );
  return (
    <div className="perks-list-container">
      <ul className="reactivate-perks-list">
        {renderListItem(currentList, 0, 4)}
      </ul>
      <ul className="reactivate-perks-list">
        {renderListItem(currentList, 4, currentList.length)}
      </ul>
    </div>
  );
};

PerksList.defaultProps = {
  membership: '',
};

PerksList.propTypes = {
  membership: PropTypes.string,
};

PerksList.displayName = 'PerksList';

export default PerksList;
